var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#6C6B6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.912 13V11.632H8.216V7.756H6.212V6.4H9.656V11.632H11.696V13H5.912ZM8.816 5.296C8.512 5.296 8.272 5.22 8.096 5.068C7.92 4.908 7.832 4.696 7.832 4.432C7.832 4.168 7.92 3.96 8.096 3.808C8.272 3.648 8.512 3.568 8.816 3.568C9.12 3.568 9.36 3.648 9.536 3.808C9.712 3.96 9.8 4.168 9.8 4.432C9.8 4.696 9.712 4.908 9.536 5.068C9.36 5.22 9.12 5.296 8.816 5.296Z",
    fill: "#FFF7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.770b74e19eacea2b63c5f25fc9e8a3e7.svg";
export { ForwardRef as ReactComponent };